<template>
    <div>
        <section class="login-form">
            <v-container>
                <v-row v-if="false">
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h1 class="section-title">Přihlásit se</h1>
                    </v-col>
                </v-row>
                <v-row>
                    <section class="addpoint">
                        <v-container>
                            <v-row>
                                <v-col cols="14" offset="1" md="10" offset-md="3">
                                    <h2 class="section-subtitle">Prázdninový turnaj byl ukončen a nové zatím nejsou naplánovány. Děkujeme</h2>
                                </v-col>
                            </v-row>
                        </v-container>
                    </section>
                </v-row>
                <v-row v-if="false">
                    <v-col cols="14" offset="1" sm="8" offset-sm="4">
                        <v-card flat light>
                            <form @submit.prevent="onSignIn">
                                <v-card-text>
                                    <v-text-field
                                        label="E-mail"
                                        v-model.trim="email"
                                        type="email"
                                        light
                                        :rules="rules.email"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="Heslo"
                                        light
                                        v-model.trim="password"
                                        type="password"
                                        :rules="rules.password"
                                    ></v-text-field>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn color="secondary" :to="{ name: 'lostPassword' }" class="btn-lost-password"
                                           text>Zapomenuté heslo
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" light class="primary" :disabled="loading || !isFormValid"
                                           :loading="loading">
                                        Přihlásit
                                    </v-btn>
                                </v-card-actions>
                            </form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <cta-block></cta-block>
    </div>
</template>
<style type="text/scss" scoped>
    .btn-lost-password {
        float: right;
    }

    @media only screen and (max-width: 800px) {
        .btn-lost-password {
            float: none;
        }
    }
</style>
<script>
    import { validator } from '../plugins/validator'
    import { LOGIN_REQUEST } from '../store/actions/user'
    import CtaBlock from '../components/Graphics/CtaBlock.vue'

    export default {
        components: {
            CtaBlock,
        },
        data () {
            return {
                email: '',
                password: '',
                loading: false,
            };
        },
        computed: {
            isFormValid () {
                return this.email !== '' && validator.email(this.email) === true && this.password !== '';
            },
            rules () {
                return {
                    email: [validator.required, validator.email],
                    password: [validator.required],
                };
            },
        },
        methods: {
            async onSignIn () {
                if (!this.isFormValid) {
                    return;
                }

                const credentials = {
                    email: this.email,
                    password: this.password,
                };

                try {
                    this.loading = true;
                    await this.$store.dispatch('user/' + LOGIN_REQUEST, credentials);

                    try {
                        const backlink = localStorage.getItem('login-backlink');
                        const backLinkRoute = JSON.parse(backlink);
                        if (backLinkRoute.name !== 'signIn') {
                            await this.$router.push(backLinkRoute).catch(e => {});
                        }
                        localStorage.removeItem('login-backlink');
                    } catch (e) {
                        await this.$router.push({ name: 'dashboard' }).catch(e => {});
                    } finally {
                        this.$toast.success('Přihlášení bylo úspěšné. Vítejte zpět!');
                    }
                } catch (e) {
                    this.$toast.error('Přihlášení nebylo úspěšné. Zkontrolujte své přihlašovací údaje.');
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>
